export const routePermissions = {
  '/waybills': 'waybill:list', '/full-map': 'fullmap:view', '/alarms': 'alarm:list',
  '/fences': 'fence:list', '/vehicles': 'vehicle:list', '/drivers': 'driver:list',
  '/addresses': 'address:list', '/routes': 'route:list', '/users': 'system:user:list',
  '/roles': 'system:role:list', '/menus': 'system:menu:list',
  '/dictionaries': 'system:dict:list', '/settings': 'system:config:list',
  '/api-audits': 'system:api-audit:list',
  '/api-docs': 'system:api-doc:list', '/callback-settings': 'system:callback:list',
  '/vehicle-monitor/positions': 'truck:position', '/vehicle-monitor/tracks': 'truck:track', '/vehicle-monitor/network': 'truck:network',
  '/waybills/create': 'waybill:add', '/routes/create': 'route:add', '/routes/planner': 'route:add'
}

export function buildNavigation(menus) {
  const nodes = (menus || []).filter(menu => Number(menu.type) !== 2 && Number(menu.status) === 1)
  const build = (parentId, ancestors) => nodes.filter(menu => String(menu.parentId || '0') === parentId)
    .filter(menu => !ancestors.includes(String(menu.id))).map(menu => {
      const children = build(String(menu.id), [...ancestors, String(menu.id)])
      return { ...menu, children }
    }).filter(menu => menu.children.length || routePermissions[menu.path])
  return build('0', [])
}

export function firstAuthorizedPath(user) {
  const menu = (user && user.menus || []).find(item => Number(item.type) === 1 &&
    Number(item.status) === 1 && routePermissions[item.path] &&
    (user.superAdmin || [routePermissions[item.path]].flat().some(permission => (user.permissions || []).includes(permission))))
  return menu ? menu.path : '/forbidden'
}
